module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ppelv6-4d98df9afa95b55ddfb9330dd4a054b0.jpg";